import { ProtectedRoute } from "@app/protected-route";
import StressTest from "@pages/stress-test/stress-test";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/stress-test/")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<ProtectedRoute requiredPermissions={["perform_ifrs", "ifrs_config"]}>
			<StressTest />
		</ProtectedRoute>
	);
}
